export function convertVideoUrlToEmbed(url: string): string {
  if (url?.includes("vimeo")) {
    const match = url.match(/vimeo\.com\/(\d+)/);

    if (match) return `https://player.vimeo.com/video/${match[1]}?z=0`;

    return url;
  }

  const match = url.match(/(?:(?:watch\?v=)|(?:youtube\.be\/))([^&\/\s]+)/);

  if (match) {
    return `https://www.youtube.com/embed/${match[1]}?modestbranding=1`;
  }

  return url;
}
